import React from 'react';
import FileCardItem from '../FileCardItem/FileCardItem.component';
import FileItem, { FileItemProps } from '../FileItem/FileItem.component';
import { FileActionMenuItem } from '../FolderView/FileActionMenuItems';


export type FileListProps = {
  handleOnPathClicked: (file: FileItemProps) => void;
  actionMenuItems:  FileActionMenuItem[];
  onActionMenuItemClick?: (file: FileItemProps, action: string) => void;
  onChangeChecked?: (file: FileItemProps, checked: boolean) => void;
};

type Props = {
  listType: string;
  fileList: FileItemProps[];
  fileListProps: FileListProps;
}

const renderFileList = (fileList: FileItemProps[], fileListProps: FileListProps) => {
  return (
    <>
      {
        fileList.map((file, index) => (
          <FileItem
            {...file}
            key={`${file.name}-${index}`}
            isOdd={(index % 2) === 1}
            {...fileListProps}
          />
        ))
      }
    </>
  );
};

const renderFileGrid = (fileList: FileItemProps[], fileListProps: FileListProps) => {
  return (
    <>
      {
        fileList.map((file, index) => (
          <FileCardItem
            {...file}
            key={`${file.name}-${index}`}
            isOdd={(index % 2) === 1}
            {...fileListProps}
          />
        ))
      }
    </>
  );
};

const FileListView = ({
  listType,
  fileList,
  fileListProps
}: Props) => {
  return (
    <>
      { listType === 'list' && renderFileList(fileList, fileListProps)}
      { listType === 'grid' && renderFileGrid(fileList, fileListProps)}
    </>
  )
}

export default FileListView;
